var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.likes && _vm.likes.length > 0
        ? _c("div", { staticClass: "likes-overview" }, [
            _c(
              "span",
              { staticClass: "likes-overview__text" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "view-user",
                        params: { user_id: _vm.likes[0].id },
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.likes[0].id === _vm.user.id
                            ? "You"
                            : _vm.likes[0].name
                        ) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.likes.length > 1
                  ? [
                      _vm._v("\n                and "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.$modal.show(
                                `other-likes-${_vm.sectorPost}`
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.likes.length - 1) +
                              " " +
                              _vm._s(
                                _vm.likes.length - 1 > 1 ? "others" : "other"
                              )
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v("\n            liked this\n        "),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "likes-overview__avatars" },
              _vm._l(_vm.likes.slice(0, 3), function (user) {
                return _c("img", {
                  attrs: {
                    src: user.avatar ? user.avatar.url : "//placehold.it/32x32",
                    alt: `Profile Image for ${user.name}`,
                  },
                })
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("modal", { attrs: { name: `other-likes-${_vm.sectorPost}` } }, [
        _c("h2", [_vm._v("Users who liked this")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "other-likes-list" },
          _vm._l(_vm.likes, function (user) {
            return _c(
              "li",
              [
                _c("UserCard", {
                  attrs: { user: user, borderless: true, small: true },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }